import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import moment from 'moment/moment';
import { Row, Col } from 'antd';
import { DatePickerField } from 'redux-form-antd';
import FormValueSelector from '../../../containers/FormValueSelector';
import { CombinedRangePicker } from '../../../services/ant-redux';

class RangePicker extends Component {
  startDefault = moment('00:00:00', 'HH:mm:ss');

  endDefault = moment('23:59:00', 'HH:mm:ss');

  state = {
    startValue: null,
    endValue: null,
    endOpen: false,
  };

  onStartChange = value => {
    this.onChange('startValue', value);
  };

  onEndChange = value => {
    this.onChange('endValue', value);
  };

  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  disabledStartDate = startValue => {
    const { endValue } = this.state;
    if (!startValue || !endValue) {
      return false;
    }
    return moment(startValue).valueOf() > moment(endValue).valueOf();
  };

  disabledEndDate = endValue => {
    const { startValue } = this.state;
    if (!endValue || !startValue) {
      return false;
    }
    return moment(endValue).valueOf() <= moment(startValue).valueOf();
  };

  handleStartOpenChange = open => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleEndOpenChange = open => {
    this.setState({ endOpen: open });
  };

  dayDiff = (end, start) => Math.ceil(moment.duration(moment(end).diff(moment(start))).asDays());

  CombinedPicker = () => {
    const { formItemLayout, showTime } = this.props;

    return (
      <Field
        {...formItemLayout}
        showTime={showTime}
        parse={a => {
          if (Array.isArray(a)) {
            return a.map(v => (moment(v).isValid() ? v : moment(v).format(this.props.apiFormat)));
          }
          return a;
        }}
        dateFormat={this.props.displayFormat}
        label="Dates"
        name="rangepicker"
        component={CombinedRangePicker}
        placeholder={['Start', 'End']}
        extra={
          <FormValueSelector fieldName="rangepicker">
            {rangepicker => (
              <span>
                {Array.isArray(rangepicker) && this.dayDiff(rangepicker[1], rangepicker[0])} day(s)
              </span>
            )}
          </FormValueSelector>
        }
      />
    );
  };

  DefaultPicker = () => {
    const { startValue, endValue, endOpen } = this.state;
    const { formItemLayout, showTime } = this.props;

    return (
      <Row type="flex" className="ant-form-item-no-colon">
        <Col className="ant-form-item-label" {...formItemLayout.labelCol}>
          <label htmlFor="Dates">Dates</label>
        </Col>
        <Col>
          <Field
            disabledDate={this.disabledStartDate}
            placeholder="Start"
            value={startValue}
            onOpenChange={this.handleStartOpenChange}
            name="start_date"
            showTime={
              showTime === false
                ? false
                : {
                    defaultValue: this.startDefault,
                  }
            }
            parse={a => a && moment(a).format(this.props.apiFormat)}
            dateFormat={this.props.displayFormat}
            component={DatePickerField}
          />
        </Col>
        <Col>
          <Field
            disabledDate={this.disabledEndDate}
            placeholder="End"
            value={endValue}
            open={endOpen}
            onOpenChange={this.handleEndOpenChange}
            name="end_date"
            showTime={
              showTime === false
                ? false
                : {
                    defaultValue: this.endDefault,
                  }
            }
            parse={a => a && moment(a).format(this.props.apiFormat)}
            dateFormat={this.props.displayFormat}
            component={DatePickerField}
            extra={
              <FormValueSelector
                selector={select => {
                  if (endValue !== select('end_date')) this.onEndChange(select('end_date'));

                  if (startValue !== select('start_date')) this.onStartChange(select('start_date'));

                  return {
                    result: this.dayDiff(select('end_date'), select('start_date')),
                  };
                }}
              >
                {({ result }) => result && <span>{result} day(s)</span>}
              </FormValueSelector>
            }
          />
        </Col>
      </Row>
    );
  };

  render() {
    const { combined } = this.props;
    return combined ? <this.CombinedPicker /> : <this.DefaultPicker />;
  }
}

RangePicker.defaultProps = {
  apiFormat: 'YYYY-MM-DD HH:mm:ss',
  showTime: {
    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:00', 'HH:mm:ss')],
  },
  displayFormat: 'YYYY-MM-DD HH:mm',
  combined: false,
  formItemLayout: {
    colon: false,
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  },
};

RangePicker.propTypes = {
  combined: PropTypes.bool,
};

export default RangePicker;
